const obj = JSON.parse(localStorage.getItem("authUser"));
let accessToken = `Bearer ${obj?.accessToken}`;
export default accessToken;
